import { render } from "./InfoM.vue?vue&type=template&id=56e0672d&scoped=true"
import script from "./InfoM.vue?vue&type=script&lang=js"
export * from "./InfoM.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e0672d"]])

export default __exports__